(() => {
  const modal = document.getElementById('MRPContactModal');

  if (!modal) return;

  const dialog = modal.querySelector('.mrp-contact-modal__dialog');
  const closeButtons = modal.querySelectorAll('[data-mrp-contact-close]');

  let trigger = null;

  function openModal(clickedTrigger) {
    trigger = clickedTrigger;

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mrp-contact-modal-open');

    requestAnimationFrame(() => {
      dialog.focus();
    });
  }

  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;
    document.body.classList.remove('mrp-contact-modal-open');

    if (trigger) {
      trigger.focus();
      trigger = null;
    }
  }

  document.addEventListener('click', (event) => {
    const contactLink = event.target.closest('a[href="#contact-us"]');

    if (!contactLink) return;

    event.preventDefault();
    openModal(contactLink);
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', (event) => {
    if (modal.hidden) return;

    if (event.key === 'Escape') {
      closeModal();
    }

    if (event.key === 'Tab') {
      const focusable = modal.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
})();